import React from 'react';

interface MintoLogoProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  showSubtitle?: boolean;
  subtitleClassName?: string;
}

const MintoLogo: React.FC<MintoLogoProps> = ({ size = 'md', className = '', showSubtitle = false, subtitleClassName }) => {
  const sizeConfig = {
    sm: { textClass: 'text-2xl', subtitleClass: 'text-sm' },
    md: { textClass: 'text-3xl', subtitleClass: 'text-sm' },
    lg: { textClass: 'text-5xl', subtitleClass: 'text-lg' },
  };

  const config = sizeConfig[size];

  return (
    <span className={`inline-flex flex-col ${className}`} aria-label="minto - Phone Repair Ab Minto Mein">
      <span className={`${config.textClass} font-bold leading-none`}>minto</span>
      {showSubtitle && (
        <span className={`${config.subtitleClass} ${subtitleClassName || 'text-gray-500'} font-normal mt-0.5`}>
          Phone Repair Ab Minto Mein
        </span>
      )}
    </span>
  );
};

export default MintoLogo;
